import React from "react"
import PageContent from "components/layout/PageContent"
import { DioboxEvent } from "sharedTypes"
import TitleWithSubtitle from "../TitleWithSubtitle"
import GuestActionsForm from "./GuestActionsForm"

type Props = {
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const GuestActions = ({ event, updateEvent }: Props) => (
  <PageContent noPadding>
    <TitleWithSubtitle
      title="Guest Actions"
      subtitle="Choose how guests can complete and update their registration."
    />
    <GuestActionsForm event={event} updateEvent={updateEvent} />
  </PageContent>
)

export default GuestActions
